var amdi18n={"__root":{"app_not_available":"TR03124Client is not available","platform_not_supported":"TR03124Client doesn't support the current platform","authentication_option_not_supported":"TR03124Client doesn't support the given authentication option","started":"Manual recovery strategy started","succeeded":"Manual recovery strategy succeeded","failed":"Manual recovery strategy failed","stopped":"Manual recovery strategy stopped","description":"A suitable eID-Client is already running. The eID procedure may be started."},"__de":{"description":"Es läuft bereits ein geeigneter eID-Client. Der eID-Vorgang kann durchgeführt werden."}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/model/recoverystrategy/nls/ManualRecoveryStrategy_strings.js
// module id = 296
// module chunks = 3